import {FullInfoUser} from "../types/api/authorization/user.types";

export function getFullName(user: FullInfoUser) {
    if (user)
        return `${user.name} ${user.lastName}`;
    else
        return ""
}